import { render } from "./LyricsModal.vue?vue&type=template&id=1fb1758f&scoped=true"
import script from "./LyricsModal.vue?vue&type=script&lang=js"
export * from "./LyricsModal.vue?vue&type=script&lang=js"

import "./LyricsModal.vue?vue&type=style&index=0&id=1fb1758f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb1758f"]])

export default __exports__